import { swaDate } from "../swaDate";

export const removeTimeZone = (str) => {
  const offset = swaDate.parseZone(str).utcOffset() * 60 * 1000;

  return swaDate.utc(new swaDate.utc(str) + offset).format("YYYY-MM-DDTHH:mm:ss");
};
